/**
 * Un document parti par courriel, tel que le serveur le rend.
 *
 * Une entrée par DESTINATAIRE : chaque message est envoyé séparément, et
 * chacun peut réussir ou échouer de son côté.
 *
 * L'objet du message et les noms de pièces jointes ne sortent pas de l'API :
 * un nom de bulletin porte le nom du salarié (minimisation, audit du 01/09).
 */
export interface EnvoiDocument {
  uuid: string;
  /** L'exécution d'automatisation à l'origine de l'envoi, s'il y en a une. */
  executionUuid: string | null;
  typeDocument: 'dsn' | 'bulletins' | 'edition' | 'facture' | 'autre';
  destinataire: string;
  /** L'adresse réellement utilisée pour partir, qui n'est pas toujours celle du cabinet. */
  expediteur: string;
  statut: 'envoye' | 'echec';
  messageErreur: string | null;
  envoyeLe: string;
}

/** Le nom que porte chaque nature de document à l'écran. */
export const NOM_TYPE_DOCUMENT: Record<EnvoiDocument['typeDocument'], string> =
  {
    dsn: 'DSN',
    bulletins: 'Bulletins',
    edition: 'Édition',
    facture: 'Facture',
    autre: 'Document',
  };
